<template>
	<div class="modules px-12">
		<NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
				<v-list flat>
					<v-list-item-group>
						<v-list-item
							v-for="plan in subscriptionPlans"
							:key="plan.id"
							style="border: 1px solid #e0e0e0; border-radius: 5px"
							color="primary"
						>
							<v-list-item-icon class="mr-3">
								<v-icon color="primary">add_to_queue</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>{{plan.name_pt}}</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action class="primary--text">
								<v-tooltip top>
									<template v-slot:activator="{ on }">
										<v-btn icon v-on="on" :to="{name: 'edit-subscription-plan', params: {pid: plan.id, plan: plan}}">
											<v-icon color="primary">edit</v-icon>
										</v-btn>
									</template>
									<span v-translate>Edit</span>
								</v-tooltip>
							</v-list-item-action>
						</v-list-item>
					</v-list-item-group>
				</v-list>
				<v-row no-gutters class="mt-4">
					<v-col cols="4">
						<v-form ref="form">
							<v-row no-gutters align="center">
								<v-text-field
									v-model="referralFreeDays"
									class="pl-2 text-caption"
									outlined
									dense
									hide-details
									label="Dias grátis de referral"
									:rules="[required, isInteger]"
								/>
								<v-btn depressed color="secondary" class="ml-2 primary--text" @click="saveReferralFreeDays" :loading="savingReferralFreeDays">
									<translate>Save</translate>
								</v-btn>
							</v-row>
						</v-form>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import axios from "axios";

export default {
	name: "SubscriptionPlans",
	components: {
		NavBar
	},
	data: () => ({
		subscriptionPlans: [],
		referralFreeDays: null,
		savingReferralFreeDays: false
	}),
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Subscription Plans"),
					disabled: true,
					link: true
				}
			];
		},
		required() {
			return value => !!value || this.$gettext("Required.");
		},
		isInteger() {
			return value => Number.isInteger(Number(value)) || this.$gettext("Invalid.");
		},
	},
	methods: {
		saveReferralFreeDays() {
			if(this.$refs.form.validate()) {
				this.savingReferralFreeDays = true;
				axios
				.post("/admin/dashboard/subscription-plans/referral-free-days", {'referral_free_days': this.referralFreeDays})
				.then(response => {
					console.log(response.data);
					this.savingReferralFreeDays = false;
				})
				.catch(error => {
					console.log(error);
					this.savingReferralFreeDays = false;
				});
			}
		}
	},
	created() {
		axios
			.get("/admin/dashboard/subscription-plans")
			.then(response => {
				console.log(response.data);
				this.subscriptionPlans = response.data.subscription_plans;
				this.referralFreeDays = response.data.referral_free_days;
			})
			.catch(error => console.log(error));
	}
};
</script>